//@flow
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import cloneDeep from 'lodash.clonedeep'
import isEqual from 'lodash.isequal'
import { isProduction } from '../utils'
import Audio from './Audio'
import QuestionRenderer from '../components/QuestionRenderer'

const QuizDiv = styled.div`
  display: flex;
  position: relative;
  background-color: white;
  overflow: hidden;
  flex-grow: 1;
`

type Props = {
  showNextButton: Function,
  hideNextButton: Function,
  refetchQuestion: Function,
  question: global.Question,
}
/**
 * Responsible for creating, managing and rendering a quiz.
 * @memberof components
 */
class Question extends Component {
  quizReady: Promise<void>
  props: Props
  static displayName = 'Question'
  static childContextTypes = {
    onQuestionStateChange: PropTypes.func,
    questionId: PropTypes.string,
  }

  state: {
    playAudioSrc: string,
    questionState: *,
    questionStartTime: ?number,
  } = {
    playAudioSrc: '',
    questionState: null,
    questionStartTime: null,
  }

  getChildContext() {
    return {
      onQuestionStateChange: this.handleQuestionChange,
      questionId: this.props.question && this.props.question.id,
    }
  }

  getInitialQuestionState(props: Props) {
    const questionState = props.question.display.initialState
    return cloneDeep(questionState)
  }

  componentDidMount() {
    if (this.props.question) {
      this.setState({
        questionState: this.getInitialQuestionState(this.props),
        questionStartTime: Date.now(),
      })
    }
  }

  componentDidUpdate(prevProps: Props) {
    // if changing questions then reset question state
    if (
        this.props.question &&
      (!prevProps.question || prevProps.question.id !== this.props.question.id)
    ) {
      this.setState({
        questionState: this.getInitialQuestionState(this.props),
        questionStartTime: Date.now(),
      })
    }
  }

  handleQuestionChange = (questionState: any) => {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(questionState)
    }
    this.setState({ questionState }, () => {
      const { initialState } = this.props.question.display
      if (isEqual(questionState, initialState)) {
        this.props.hideNextButton()
      } else {
        this.props.showNextButton()
      }
    })
  }

  reset() {
    const { question } = this.props
    this.setState({
      questionState: this.getInitialQuestionState(this.props),
      questionStartTime: Date.now(),
    })
    // if we are in dev then refetch the question
    if (!isProduction()) {
      this.props.refetchQuestion(question.id)
    }
  }

  getAnswer(): LearnerAnswer {
    return cloneDeep(this.state.questionState)
  }

  getStartTime(): ?number {
    return this.state.questionStartTime
  }

  playAudio = (playAudioSrc: string) => this.setState({ playAudioSrc })
  stopAudio = () => this.setState({ playAudioSrc: '' })

  render(): React.Element<*> {
    const { playAudioSrc, questionState } = this.state
    const { question } = this.props
    return (
      <QuizDiv>
        <Audio
          playing={!!playAudioSrc}
          src={playAudioSrc}
          onEnded={this.stopAudio}
        />
        {question && (
          <QuestionRenderer
            onChange={this.handleQuestionChange}
            questionState={questionState}
            question={question}
          />
        )}
      </QuizDiv>
    )
  }
}

export default Question



// WEBPACK FOOTER //
// ./src/components/Question.js